import { Link } from 'react-router-dom';
import { LegalPage } from './LegalPage';
import { LEGAL_CONTACT, LEGAL_VERSIONS, PLATFORM_COMMISSION_PCT } from '@makhe/shared';

export default function SellerAgreementPage() {
  return (
    <LegalPage title="Seller Agreement" lastUpdated={LEGAL_VERSIONS.sellerAgreement}>
      <p>
        This Seller Agreement applies when you onboard as a creator on Makhe. By completing seller
        onboarding you agree to this agreement, our <Link to="/legal/terms">Terms</Link>, and{' '}
        <Link to="/legal/community-guidelines">Community Guidelines</Link>.
      </p>

      <h2>1. Independent contractor</h2>
      <p>
        You are an independent contractor, not an employee of Makhe. You control your schedule,
        pricing (within tier structure), and which bookings you accept. You are responsible for
        your own tax obligations.
      </p>

      <h2>2. Student status</h2>
      <p>
        You represent that you are a currently enrolled student and will keep your verification
        current. Makhe may suspend selling privileges if verification expires or is revoked.
      </p>

      <h2>3. Services &amp; hygiene</h2>
      <p>
        You will perform only beauty services you are qualified to offer, use sanitised tools,
        follow reasonable hygiene standards, and decline service if a client has a contagious
        condition that makes the service unsafe.
      </p>

      <h2>4. Safety preferences</h2>
      <p>
        You may set client and location preferences (e.g. women clients only, same institution,
        first-booking location rules). Makhe enforces these preferences in the booking system.
        You may decline any booking request you are uncomfortable with before accepting.
      </p>

      <h2>5. Commission &amp; payouts</h2>
      <p>
        Makhe charges {PLATFORM_COMMISSION_PCT}% on completed bookings. You are paid{' '}
        <strong>directly by Paystack into your own bank account</strong> via your Paystack
        subaccount — Makhe never holds your earnings. Payment is settled once the buyer confirms
        completion or the booking auto-confirms, per our{' '}
        <Link to="/legal/refunds">Refund Policy</Link>. You must provide accurate bank details so
        your subaccount can be set up.
      </p>

      <h2>6. Content licence</h2>
      <p>
        You grant Makhe a non-exclusive licence to use your listing photos and videos for
        platform marketing and discovery. You warrant you have rights to all content you upload.
      </p>

      <h2>7. Prohibited services</h2>
      <p>
        No illegal services, unlicensed medical procedures, or services you are not competent to
        perform. Makhe may remove listings that violate this section.
      </p>

      <h2>8. Conduct &amp; suspension</h2>
      <p>
        No-shows, harassment, or safety reports may result in warnings, suspension, or permanent
        ban. See Community Guidelines.
      </p>

      <h2>9. Indemnity</h2>
      <p>
        You indemnify Makhe against claims arising from your services, except where caused by
        Makhe&apos;s gross negligence or wilful misconduct.
      </p>

      <h2>10. Contact</h2>
      <p>
        <a href={`mailto:${LEGAL_CONTACT.email}`}>{LEGAL_CONTACT.email}</a>
      </p>
    </LegalPage>
  );
}
